// extracted by mini-css-extract-plugin
export default {"modalFooterContainer":"CardModalFooter_modalFooterContainer__Y2zl3"};